import { useQuery } from '@tanstack/react-query'

import type { GetEstimateInfoMinimalByIdResponse } from '../../types/estimate.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

/** Même projection que le parcours public, derrière la vérification d'appartenance. */
export const useGetMyEstimateResponseInfoMinimalQuery = ({ id }: { id: string }) =>
  useQuery({
    queryFn: async () => {
      const response = await apiClient.client.get<GetEstimateInfoMinimalByIdResponse>(
        `/me/estimate-responses/${id}/info-minimal`
      )
      return response.data
    },
    queryKey: meKeys.estimateResponseInfoMinimal(id),
  })
